import { Mark } from "./Logo";
import { ventures } from "../data/ventures";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ventures.map((v) => (
      <span key={v.slug} className="flex items-center">
        <span className="px-8 font-display text-5xl font-extrabold uppercase tracking-tight md:text-7xl">{v.short}</span>
        <span className="font-serif text-3xl italic text-ember md:text-5xl">{v.kind === "Charity" ? "gives" : "builds"}</span>
        <Mark className="mx-8 h-8 w-8 text-ember/80 md:h-10 md:w-10" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="ventures-marquee" className="relative overflow-hidden border-y border-bone/10 bg-ink py-8 text-bone md:py-12">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
